import Phase from "@/realize-shared/model/Phase";
import type { RoomID } from "@/realize-shared/model/Types";
import Eyecon from "@/assets/img/symbolic/eyeball.svg?react";
import { formatNumberToLetter } from "@/util/Util";
import PlayerSubmissionClock from "@/web/components/PlayerSubmissionClock";
import CloseIcon from "@/assets/img/symbolic/quit.svg?react";
import React from "react";
import type { ProcessedSpectator } from "@/local-shared/model";
import type { Socket } from "socket.io-client";
import type { ClientToServerEvents, ServerToClientEvents } from "@/local-shared/socket-events";

export default function TopSection({
    roomID,
    socket,
    gamePhase,
    exit,
}: {
    roomID: RoomID;
    socket: Socket<ServerToClientEvents, ClientToServerEvents>;
    gamePhase: Phase;
    exit: () => void;
})
{
    const [spectators, setSpectators] = React.useState<ProcessedSpectator[]>([]);


    React.useEffect(() =>
    {
        const handleSpectatorsUpdate = (data: unknown) =>
        {
            const newSpectators = data as ProcessedSpectator[];

            setSpectators(newSpectators);
        };

        socket.on("spectatorList", handleSpectatorsUpdate);

        // Request initial spectators list
        socket.emit("spectateRoom", roomID);

        return () =>
        {
            socket.off("spectatorList", handleSpectatorsUpdate);
            socket.emit("stopSpectating", roomID);
        };
    }, [socket, roomID]);

    return (
        <div className="flex flex-row items-center justify-between w-full h-8 pr-4 py-2">
            <div className="flex gap-2 items-center justify-between px-4 py-2">
                <button
                    onClick={exit}
                >
                    <CloseIcon
                        className={Wind.style({
                            color: "text-[#F9DC5C]",
                        }).class}
                    />
                </button>
                {gamePhase !== Phase.LOBBY && (<PlayerSubmissionClock showWaiting={false} />)}
            </div>
            <div
                className={Wind.style({
                    flexGrow: "grow",
                }).class}
            >

            </div>
            <div className="flex flex-col items-center justify-center">
                <div
                    className={Wind.style({
                        color: "text-white",
                        fontFamily: "font-default",
                        fontWeight: "font-extrabold",
                        fontSize: "text-2xl",
                        lineHeight: "leading-[150%]",
                        display: "flex",
                        alignItems: "items-center",
                        gap: "gap-2",
                    }).class}
                >
                    <Eyecon
                        className={Wind.style({
                            width: "w-6",
                            height: "h-6",
                            color: "text-poppy-yellow",
                        }).class}
                    />
                    {formatNumberToLetter(spectators.length)}
                </div>
            </div>
        </div>
    );
}
